import { reviewedReplacementRoute } from "./landing-reviewed-replacements.mjs";

/** Keep native composition and art, replacing only its first editorial slot. */
export function withReviewedCmsEditorial(source, blocks) {
  const sections = source.sections || [];
  const editorialIndex = sections.findIndex(section => section.kind === "editorial");
  return { ...source, sections: editorialIndex < 0
    ? [{ kind: "editorial", blocks }, ...sections]
    : sections.map((section, index) => index === editorialIndex && section.kind === "editorial"
      ? { ...section, blocks } : section) };
}

const editorialOnlySourceReviews = {
  "/new-jersey-classic-car-rental": "469af8a8771d5e4ab4a7e6cb57eafe62d25a9a9dfd04b707b5528855b4c49b44",
  "/pre-war-and-vintage-car-rental": "80ed2744a2459aae0203e79217b782f02e7a2300278ff1184746affc40b0246e",
};

const nativeOwnerReviews = [
  { path: "/List", ids: [84, 1764], hash: "4720d8712a1c153d3844511b3144c6875f444d32dc1083a6b6e2758eb6322d03" },
  { path: "/Film_and_Photoshoots", ids: [76, 1815], hash: "57635e46e0f4878f0da3ee7ff89d65a7760f82993f37c9e812dff39595677090" },
  { path: "/moviecars", ids: [35, 1746], hash: "4cdfe0bbc8352e89c8199ea6f87c5f24906d29b9952bd87eaf6d6e11fa700b59" },
  { path: "/vintagecars", ids: [26, 1763], hash: "1ab34dcdd9da936fb9a0910f7edfa0a2445bbbee6cecd37b236f48492db1f17d" },
];

// This is a reviewed owner-information page, not an inventory landing.
// Keep the exception bound to its immutable identity and returned native copy.
export function hasReviewedNoInventoryPolicy(page) {
  if (!page || typeof page !== "object") return false;
  const policy = page.reviewedInventoryPolicy;
  const body = typeof page.hero_body === "string" ? page.hero_body : "";
  if (policy?.kind === "reviewed-source-template-no-stock-slot") {
    const path = `/${String(page.full_path || "").replace(/^\/+|\/+$/g, "")}`;
    const reviewedHash = editorialOnlySourceReviews[path];
    return !!reviewedHash && policy.version === 1 && policy.path === path &&
      policy.sourceHash === reviewedHash &&
      page.active !== false && page.is_indexable === true;
  }
  if (policy?.kind === "reviewed-native-owner-editorial-no-inventory") {
    const review = nativeOwnerReviews.find((row) => row.path === policy.path);
    const proof = page.sourceProvenance?.nativeHostEditorialReview;
    return !!review && policy.version === 1 && review.ids.includes(policy.pageId) &&
      page.id === policy.pageId && `/${page.full_path}` === review.path &&
      policy.countryCode === "US" && policy.language === "en" &&
      // Reviewed original world records have a null locale; their US copies
      // have "us". The same immutable body/identity proof is required for both.
      (page.locale === "us" || page.locale === null) && page.language === "en" && page.page_type === "host" &&
      page.category === "owner-acquisition" && page.filter_params?.country_code === "US" &&
      page.active === true && page.is_indexable === true && page.sourceLanguageVerified === true &&
      policy.bodySha256 === review.hash && proof?.activeBodySha256 === review.hash &&
      proof.path === page.full_path && proof.pageId === page.id &&
      body.replace(/<[^>]*>/g, "").trim().length >= 300 &&
      (body.match(/<h2\b/gi) || []).length >= 2;
  }
  const replacement = reviewedReplacementRoute(`/${String(page.full_path || "").replace(/^\/+|\/+$/g, "")}`);
  if (replacement) {
    return policy?.kind === "reviewed-replacement-editorial-no-inventory" &&
      policy.version === 1 && policy.path === replacement.path &&
      policy.pageId === replacement.pageId && page.id === replacement.pageId &&
      policy.countryCode === "US" && policy.language === "en" &&
      page.locale === "us" && page.language === "en" &&
      page.active === true && page.is_indexable === true &&
      page.category === (replacement.kind === "owner" ? "owner-acquisition" : "information") &&
      page.filter_params?.country_code === "US" &&
      page.sourceLanguageVerified === true &&
      page.sourceProvenance?.activeBodySha256 === replacement.bodySha256 &&
      ["repair-ready", "historical-ok"].includes(page.restorationVisibility) &&
      body.replace(/<[^>]*>/g, "").trim().length >= 300 &&
      (body.match(/<h2\b/gi) || []).length >= 2;
  }
  return policy?.kind === "reviewed-owner-editorial-no-inventory" &&
    policy.version === 1 &&
    policy.path === "/be/rejoignez-nous" &&
    policy.pageId === 1075 &&
    policy.countryCode === "BE" &&
    policy.language === "nl" &&
    page.id === 1075 &&
    String(page.full_path || "").replace(/^\/+|\/+$/g, "") === "be/rejoignez-nous" &&
    page.locale === "be" && page.language === "nl" &&
    page.category === "owner-acquisition" &&
    page.page_type === "owner acquisition (list your car)" &&
    page.filter_params?.country_code === "BE" &&
    page.sourceLanguageVerified === true &&
    ["repair-ready", "historical-ok"].includes(page.restorationVisibility) &&
    body.replace(/<[^>]*>/g, "").trim().length >= 300 &&
    (body.match(/<h2\b/gi) || []).length >= 2;
}